var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook.svg",
    clipPath: "url(#clip0_574_3601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5098 5.0179H3.77979V7.32459H5.5098V14.2446H8.39315V7.32459H10.4934L10.6998 5.0179H8.39315V4.0566C8.39315 3.50587 8.50387 3.28789 9.03614 3.28789H10.6998V0.404541H8.50387C6.43016 0.404541 5.5098 1.31741 5.5098 3.06588V5.0179Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_574_3601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8401,
    height: 13.8401,
    fill: "white",
    transform: "translate(0.319824 0.404541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.26c3756c661ed0d053103f6c5cf562a0.svg";
export { ForwardRef as ReactComponent };